// extracted by mini-css-extract-plugin
export default {"section":"Section_section__jVZfM","variants-list":"Section_variants-list__yOgH7","variant-wrapper":"Section_variant-wrapper__5+bVZ"};